export interface Injection {
    location: string;
    target: Function;
}
